import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import EducationsCards from "./EducationsCards";
import Chip from "@mui/material/Chip";

const labelsLeeds = [
    "Cross-Cultural Management",
    "International Marketing",
    "Marketing Strategy",
    "International Strategic Management",
    "Consumer Behaviour",
    "Global Entrepreneurship",
    "Organizational Behaviour",
    "..."
];

const labelsCUHK = [
   "Risk Measures",
   "Credit Risk Management",
   "Interest Rates and Fixed Incomes",
   "Advanced Statistical Theory in RM",
   "Simulation Tehcniques in RM",
   "..."
];

function Educations() {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <Container fluid className="education-section">
      <Container>
        <h1 className="education-heading" style={{ textAlign: "left" }}>
          <strong className="purple">Educations </strong>
          </h1>

        </Container>
      
        <Container>
          <h1 className="education-subheading" style={{ textAlign: "left" }}>
            Msc Risk Management and Data Analytics</h1>
          <h3  style={{ textAlign: "left" }}>
            <strong className="purple">Chinese University of Hong Kong </strong> </h3>
          <h3  style={{ textAlign: "left" }}>
          2025-2026 </h3>
          <br />
          <p style={{ textAlign: "left" }}>I have developed a solid foundation in <strong className="purple">credit risk</strong>. My learning covers core credit risk concepts, including <strong className="purple">credit scoring</strong> and key credit risk mitigation techniques such as <strong className="purple">netting</strong>, <strong className="purple">collateralization</strong>, <strong className="purple">central counterparties (CCPs)</strong>, and credit hedging using <strong className="purple">credit default swaps (CDS)</strong>. I gained exposure to the historical evolution of <strong className="purple">2007 financial crises</strong> and their implications for risk management practices. I studied quantitative credit risk measurement, including <strong className="purple">probability of default</strong> estimation using empirical, structural and reduced-form models (<strong className="purple">Altman’s Z-score</strong>, <strong className="purple">Merton</strong>, <strong className="purple">KMV</strong>), as well as <strong className="purple">default dependence modeling</strong> through <strong className="purple">copulas</strong> and the <strong className="purple">Vasicek</strong> framework. In addition, I learned regulatory standards under the <strong className="purple">Basel</strong> framework.</p>
          <p style={{ textAlign: "left" }}>On the <strong className="purple">market risk</strong> side, I studied risk measures such as <strong className="purple">Value at Risk</strong> and <strong className="purple">Expected Shortfall</strong>, model validation through <strong className="purple">backtesting</strong>, and advanced techniques to improve VaR estimation, including <strong className="purple">Cornish–Fisher expansion</strong>, <strong className="purple">delta–gamma approximation</strong>, and <strong className="purple">extreme value theory</strong>. I also explored volatility modeling, <strong className="purple">volatility smiles</strong>, <strong className="purple">jump-diffusion processes</strong>, and <strong className="purple">stochastic volatility models.</strong></p>
          <div className="flex-chips">
            <span className="chip-title">Course studied:</span>
            {labelsCUHK.map((label, index) => (
                <Chip key={index} className='chip' label={label} />
            ))}
          </div>
          <div style={{ height: "40px" }} /> {/* Added spacer */}
          <h4 style={{ textAlign: "left", paddingLeft: "40px" }}>Presentations</h4>
          <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
            <Col md={6} className="project-card">
              <EducationsCards
                isBlog={false}
                title="Corporate Credit Rating on Automotive Industries"
                link="pre2.pdf"
                description={
                    <>
                      Designed and implemented a corporate credit risk scorecard for global automobile manufacturers by selecting key financial and industry-specific indicators, applying factor analysis and ESG/market adjustments, and benchmarking firms through peer and rating validation analysis.
                      <br /> <br />
                      Grade: nan
                    </>
                  }
              />
            </Col>

            <Col md={6} className="project-card">
              <EducationsCards
                isBlog={false}
                title="Global Risk Assessment on ABC (中国农业银行)"
                link="pre3.pdf"
                description={
                    <>
                      Developed a weighted global risk assessment framework for the Agricultural Bank of China by analyzing financial, credit, market, operational, and other risks, concluding an overall low-risk profile.
                      <br /> <br />
                      Grade: nan
                    </>
                  }
              />
            </Col>

            <Col md={6} className="project-card">
              <EducationsCards
                isBlog={false}
                title="Foreign Exchange Derivative"
                link="FXderiv.pdf"
                description={
                    <>
                      Developed and validated a GARCH(1,1)-based FX volatility model to simulate EUR/USD dynamics, compared Black–Scholes vs GARCH option pricing, and estimated VaR/ES risk measures using Monte Carlo methods.
                      <br /> <br />
                      Grade: nan
                    </>
                  }
              />
            </Col>
          </Row>
        </Container>

        <Container style={{ marginTop: "100px" }}>
          <h1 className="education-subheading" style={{ textAlign: "left" }}>
            BSc International Business and Marketing </h1>
          <h3  style={{ textAlign: "left" }}>
            <strong className="purple">University of Leeds </strong> </h3>
          <h3  style={{ textAlign: "left" }}>
          2022-2025 </h3>
          <br />
          <p style={{ textAlign: "left" }}> During three years studying <strong className="purple">International Business and Marketing</strong>, I gained a solid foundation in global business strategies and marketing frameworks. The courses about <strong className="purple">international business</strong> covered a range of entry and expansion strategies including <strong className="purple">Foreign Direct Investment (FDI)</strong>, <strong className="purple">joint ventures</strong>, and <strong className="purple">strategic alliances</strong>. I also learned to apply key analytical frameworks such as <strong className="purple">Hofstede’s Cultural Dimensions</strong> for understanding workplace culture, <strong className="purple">Porter’s Five Forces</strong> for competitive analysis, and broader models like <strong className="purple">SWOT</strong> and <strong className="purple">PESTLE</strong> analysis for evaluating business environments.</p>
          <p style={{ textAlign: "left" }}> In the <strong className="purple">marketing</strong> curriculum, I explored the effectiveness of various <strong className="purple">promotional strategies</strong> including advertising, sales promotions, public relations, sponsorship, and digital marketing. We applied strategic tools like <strong className="purple">Porter’s Generic Strategies</strong> to assess competitive advantage, the <strong className="purple">Ansoff Matrix</strong> for identifying growth opportunities, and core marketing concepts such as <strong className="purple">Segmentation, Targeting, and Positioning (STP)</strong>, as well as the <strong className="purple">Product Life Cycle</strong> model.</p>
          <p style={{ textAlign: "left" }}> However, I found the program's structure unnecessarily prolonged. Much of the core content could have been effectively delivered in a single year, but instead was stretched over three—raising concerns about the value for tuition fees. Additionally, the course material leaned heavily on outdated that cannot keep track on fast-changing environments, theoretical models with limited real-world applicability, particularly within the marketing modules.</p>
          <div className="flex-chips">
            <span className="chip-title">Course studied:</span>
            {labelsLeeds.map((label, index) => (
                <Chip key={index} className='chip' label={label} />
            ))}
          </div>
          <div style={{ height: "40px" }} /> {/* Added spacer */}
          <h4 style={{ textAlign: "left", paddingLeft: "40px" }}>Dissertation</h4>
          <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
            <Col md={8} className="project-card">
              <EducationsCards
                title="The role of FDI on sustainable development: The case of US"
                link="https://www.researchgate.net/publication/392825691_The_role_of_FDI_on_sustainable_development_The_case_of_US"
                description="This research examines the diverse effects of FDI inflows on sustainable development in United States for the period of 1970 to 2023, concentrating on the three pillars of sustainability: economic growth, income inequality, and environmental quality. By employing autoregressive distributed lag (ARDL) and error correction models (ECM), this analysis reveal divergent patterns across these dimensions."
              />
            </Col>
          </Row>

          <h4 style={{ textAlign: "left", paddingLeft: "40px" }}>Relevant Courseworks</h4>
          <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
            <Col md={5} className="project-card">
              <EducationsCards
                isBlog={false}
                title="Consumer Behaviour"
                link="consumer_behv.pdf"
                description={
                    <>
                      Analyzing gift giving behaviours based on the theories of attitude, consumer identity, and innovation & consumer outcome.
                      <br /> <br />
                      Grade: 68% (Good)
                    </>
                  }
              />
            </Col>

            <Col md={5} className="project-card">
              <EducationsCards
                isBlog={false}
                title="International Strategic Management"
                link="inter_stra.pdf"
                description={
                    <>
                      Haidilao Strategic Report
                      <br />
                      Assessing the Internet and External environments. Reviewing the existing strategies and providing recommendations for further FDI direction.
                      <br /> <br />
                      Grade: 72% (Distinction)

                    </>
                  }
              />
            </Col>
          </Row>

        </Container>

      </Container>
    );
    }
export default Educations;